var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAscReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49602 4L13.544 4.00179L13.6303 4.01676L13.6926 4.03779L13.7513 4.06673L13.8131 4.10892L13.8706 4.16267L13.9113 4.21334L13.946 4.27081L13.9783 4.3488L13.9898 4.39191L14.0011 4.47832L14.0015 9.5C14.0015 9.77614 13.7777 10 13.5015 10C13.2561 10 13.0519 9.82312 13.0096 9.58988L13.0015 9.5L13.001 5.707L7.85782 10.8535C7.68439 11.027 7.41516 11.0464 7.22027 10.9117L7.151 10.8539L5.50037 9.20674L2.85355 11.8536C2.65829 12.0488 2.34171 12.0488 2.14645 11.8536C1.97288 11.68 1.9536 11.4106 2.08859 11.2157L2.14645 11.1464L5.14645 8.14645C5.31988 7.97301 5.58907 7.95361 5.78393 8.08833L5.85318 8.14608L7.50374 9.79318L12.293 5H8.49602C8.25056 5 8.04642 4.82312 8.00408 4.58988L7.99602 4.5C7.99602 4.22386 8.21988 4 8.49602 4Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAscReg);
export default __webpack_public_path__ + "static/media/ArrowAscReg.4993a84ac5ec8fd44a54f23ef7a266b1.svg";
export { ForwardRef as ReactComponent };